import React, { useState } from "react";
import Box from "@mui/material/Box";
import {
  DataGrid,
  gridClasses,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const BidsTable = ({ rfqs, activeTab, isLoading, storedUser }) => {
  const navigate = useNavigate();
  
  const handleCheck = (id) => {
    navigate(`/dashboard/${id}`);
  };

  const columns = [
    {
      field: "rfqId",
      headerName: "RFQ ID",
      flex: 1,
      renderCell: (params) => (
        <span
          className="table-title"
          onClick={() => handleCheck(params.row.rfqId)}
        >
          {params.row.rfqId}
        </span>
      ),
    },
    {
      field: "shortDesc",
      headerName: "Short Description",
      flex: 1,
    },
    {
      field: "name",
      headerName: "Requisitioner Name",
      flex: 1,
    },
    {
      field: "dept",
      headerName: "Requisitioner Dept.",
      flex: 1,
    },
    {
      field: "submissionDate",
      headerName: "Submission Date",
      flex: 1,
      renderCell: (params) => {
        const { rebidEndDate, submissionDate } = params.row;
        return formatDateTime(rebidEndDate || submissionDate);
      },
    },
    {
      field: "status",
      headerName: "RFQ Status",
      flex: 1,
      renderCell: (params) => 
          <span style={{
            background: "#5EC9FF",
            borderRadius: "15px",
            padding: "5px 15px",
            fontWeight: 600,
            textTransform: 'capitalize',
          }}>
            {params.row.status ? params?.row?.status.replace("_", " ") : ""}
          </span>
    },
    {
        field: "action",
        headerName: "Action",
        flex: 1,
        renderCell: (params) => (
            <Button
              className="btn-contained"
              sx={{
                margin: "0 !important",
                fontSize: "12px",
                px: 9,
                width: "0 !important",
              }}
              onClick={() => navigate(`/dashboard/view-bid-data/${params.row.rfqId}`)}
            >
              Review Quotes
            </Button>
        ),
      },
  ];

  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const [date, time] = dateString.split("T");
    const [year, month, day] = date.split("-");
    const cleanTime = time?.split(".")[0];
    return `${day}/${month}/${year} ${cleanTime}`;
  };


  const rows =
    rfqs &&
    rfqs.map((rfq) => ({
      ...rfq,
      creationDate: formatDateTime(rfq.creationDate),
      // submissionDate: formatDateTime(rfq.submissionDate),
    }));

  return (
    <Box sx={{ width: "100%", minHeight: "400px" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        loading={isLoading}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10]}
        disableRowSelectionOnClick
        disableColumnSelector
        disableDensitySelector
        disableColumnMenu
        disableColumnResize
        slots={{ toolbar: CustomToolbar }}
        getRowId={(row) => row.rfqId}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
        }
        sx={{
          position: "relative",
          border: "none",
          fontFamily: "Inter !important",

          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "700 !important",
          },
          "& .MuiDataGrid-columnHeaders": {
            background: "none !important",
            color: "black",
            fontSize: "14px",
            borderRadius: "10px",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#fff",
          },
          "& .MuiDataGrid-cell": {
            fontSize: "13px",
            border: "none",
          },
          "& .MuiDataGrid-columnSeparator": {
            display: "none",
          },
          "& .css-1ccsd5i-MuiButtonBase-root-MuiButton-root": {
            color: "#000 !important",
            border: "1px solid #B0B0B0",
            borderRadius: "12px",
            padding: 1,
          },
          "& .MuiInputBase-root-MuiInput-root::after": {
            borderBottom: "none !important",
          },
          "& .MuiInputBase-root-MuiInput-root": {
            borderBottom: "none !important",
          },
          [`& .${gridClasses.row}.even`]: {
            backgroundColor: "#EAF4FF",
            // '&:hover': {
            //   backgroundColor: "#f6f6f6",
            // },
          },
          "& .MuiInput-underline:before": {
            borderBottom: "none !important",
          },
          "& .css-5h82ro-MuiInputBase-root-MuiInput-root::after": {
            borderBottom: "none !important",
          },
        }}
      />
    </Box>
  );
};

export default BidsTable;

function CustomToolbar() {
  return (
    <GridToolbarContainer sx={{ display: "flex", justifyContent: "end" }}>
      <GridToolbarQuickFilter
        sx={{
          border: "1px solid #B0B0B0",
          borderRadius: "12px",
          padding: "4px 12px",
          "&:hover": {
            backgroundColor: "#D8E9F0",
          },
          "& .MuiInputBase-root": {
            borderRadius: "12px",
          },
          width: 300,
        }}
      />
      {/* <GridToolbarFilterButton /> */}
    </GridToolbarContainer>
  );
}